module.exports = __webpack_public_path__ + "static/media/dariaft.195088b4.jpg";